import { Box, BoxProps, Text, thc } from "@flightstats/airframe-react";
import { isWindowSmallerThan } from "../../../components/cirium/CiriumFormUtils";
import { BoxOutlinedGroupedComponents } from "../../../pages/components/styledComponent";
import { ContactPointsAlertType } from "../TravelerProfileConstants";
import React from "react";
import { ContactPoint } from "../../../headersegment/interfaces";

type ContactPointsDefinitionProps = {
    label: string,
    definition: string,
};

const ContactPointsDefinition = ({
    label,
    definition,
}: ContactPointsDefinitionProps) => {
    return (
        <Box as="li" margin="10px 0">
             <Text fontWeight="bold" inline mr="10px" spacing="1">
               {label}
             </Text>
             <Text display={{ xs: 'block', md: 'inline' }} fontWeight="normal">
               {definition}
             </Text>
           </Box>
    );
};

interface DefinitionsListProps extends BoxProps {
    isMobile: boolean;
}

const DefinitionsList = thc<DefinitionsListProps>(
    Box,
    {
        as: 'ul',
        marginLeft: {
            xs: '10px',
            md: '0px',
        },
        paddingLeft: {
            xs: '0px',
            md: '25px',
        },
        marginBottom: {
            xs: '25px',
            md: '0px',
        },
    },
    ({ isMobile }: DefinitionsListProps) => ({
        listStyleType: isMobile ? 'none' : 'disc',
    }),
);

export const ContactPointsDefinitions: React.FC<{ contactPoints: ContactPoint[] }> = ({
    contactPoints,
}) => (
    <BoxOutlinedGroupedComponents header="Definition of Alert Types">
        <DefinitionsList isMobile={isWindowSmallerThan('md')}>
            <ContactPointsDefinition
                label={'Pre-Trip'}
                definition={
                    'Alerts that are typically before a flight departs such as cancellation or delay of first flight.'
                }
            />
            <ContactPointsDefinition
                label={'Traveling'}
                definition={
                    'Alerts that are sent during a trip such as gate change and connection information.'
                }
            />
            {contactPoints.some(
                contactPoint =>
                    contactPoint.alertType ===
                    ContactPointsAlertType.HEALTH_AND_SAFETY,
            ) && (
                    <ContactPointsDefinition
                        label={'Health & Safety'}
                        definition={
                            'Alerts that are triggered by health and safety events, relative to the destinations and times of your trip.'
                        }
                    />
                )}
        </DefinitionsList>
    </BoxOutlinedGroupedComponents>
);